import type {Account, User} from './models';

export function getHostPrefix() {
    return window.location.host.endsWith('.com') ? 'com' : 'ru';
}

export function getPassportHref(internal?: boolean) {
    return internal
        ? 'https://passport.yandex-team.ru'
        : `https://passport.yandex.${getHostPrefix()}`;
}

export function getPassportAuthHref(internal?: boolean) {
    return `${getPassportHref(internal)}/auth?retpath=${encodeURIComponent(location.href)}`;
}

export function isUserSignIn(user?: User) {
    return Boolean(user && (user.uid || user.isFederationUser));
}

export function getUserName(user: User) {
    return user.displayName || user.login;
}

export function getUserDescription(user: User) {
    return user.email || user.federationName || user.federationId;
}

export function getPassportUsers(
    accounts: Account[],
    yandexuid: string,
    avatarHost: string,
): User[] {
    return accounts.map<User>((account) => ({
        ...account,
        yandexuid,
        avatarHost,
    }));
}

export function getAvatarUrl(avatar?: string, avatarData?: string) {
    if (avatarData) {
        return `data:image/jpeg;base64,${avatarData}`;
    }

    return avatar;
}
